import React from 'react';
import {Map} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {hasValue} from '@packages/utilities/string-utils';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT,
  DATA_ATTR_COMMERCE_OPTION_SET_ID,
} from '@packages/systems/commerce/constants';

import {TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getInPojo, getStringOrElse} from '@packages/utilities/data-utils';

const createOption = (
  option: {
    id: string;
    name: string;
    slug?: string;
  },
  index: number
) => {
  const value = option.id;
  const text = option.name;
  return (
    <option key={index} value={hasValue(value) ? value : ''}>
      {hasValue(text) ? text : ''}
    </option>
  );
};

const CommerceOptionSelect = Atom.createRender(
  ({attributes, classes, context, data: nodeData, generateAttributes}) => {
    const data = context.get('data');
    const shouldRender = context.get('selectorType') === 'select';
    if (data && shouldRender) {
      const {id: optionSetId, name: optionSetName, enum: optionSetEnum} = data;
      const selectClasses = classes.push('w-select');
      const options = optionSetEnum.map(createOption);
      const label = getStringOrElse(
        getInPojo(nodeData, ['defaultText']),
        'Select'
      );
      const defaultOptionText = `${label} ${optionSetName}`;

      options.unshift(createOption({id: '', name: defaultOptionText}, -1));
      const newAttributes = (attributes || Map()).merge(
        Map({
          id: `option-set-${optionSetId}`,
          [DATA_ATTR_NODE_TYPE]: NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT,
          [DATA_ATTR_COMMERCE_OPTION_SET_ID]: optionSetId,
        })
      );

      return (
        <select
          {...generateAttributes(newAttributes, selectClasses)}
          defaultValue=""
          required
        >
          {options}
        </select>
      );
    }
    return null;
  }
);

const config = createIntegratedAtom({
  displayName: 'Select Field',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Select')),
  },
  constraints: {
    ancestors: [
      {
        is: 'CommerceAddToCartOption',
        rule: 'ExactlyOne',
      },
    ],
  },
  fields: {
    defaultText: withSystem(
      {label: 'Default Text', defaultValue: 'Select'},
      TText
    ),
  },
  render: CommerceOptionSelect,
});

export default config;
